.wrapper {
  background: var(--ant-color-bg-container);
  border: 1px solid var(--ant-color-border);
  border-radius: var(--ant-border-radius);
}

.toolbar {
  display: flex;
  gap: 4px;
  padding: 6px 8px;
  background: var(--ant-color-fill-alter);
  border-bottom: 1px solid var(--ant-color-border-secondary);
}

.button {
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  font-weight: 700;
  color: var(--ant-color-text);
  cursor: pointer;
  background: var(--ant-color-bg-container);
  border: 1px solid var(--ant-color-border);
  border-radius: var(--ant-border-radius-sm);
}

.italic {
  font-style: italic;
  font-weight: 500;
}

.editor {
  min-height: 96px;
  max-height: 240px;
  padding: 8px 11px;
  overflow: auto;
  font-size: 14px;
  line-height: 1.7;
  color: var(--ant-color-text);
  outline: none;
}

.editor:empty::before {
  color: var(--ant-color-text-placeholder);
  content: attr(data-placeholder);
}

.editor p,
.editor blockquote {
  margin: 0 0 8px;
}

.editor p:last-child {
  margin-bottom: 0;
}

.editor strong {
  font-weight: 700;
  color: var(--ant-color-text-heading);
}

.editor blockquote {
  padding: 4px 0 4px 12px;
  color: var(--ant-color-text-secondary);
  border-left: 3px solid var(--ant-color-primary-border);
}
